"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _LeadFormData = _interopRequireDefault(require("../finpro/LeadFormData"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CustomHiddenLeads = props => {
  var field = props.field,
    fieldId = field.valueField.id,
    fieldName = field.valueField.name;
  var refreshData = props => {
    var leadsFields = {};
    leadsFields.agentId = _LeadFormData.default.agentId;
    leadsFields.coreAgencyNumber = _LeadFormData.default.coreAgencyNumber;
    leadsFields.subAgencyNumber = _LeadFormData.default.subAgencyNumber;
    leadsFields.agencyName = _LeadFormData.default.agencyName;
    props.onChange(fieldName, JSON.stringify(leadsFields), true, []);
  };
  (0, _react.useEffect)(() => {
    (0, _lodash.delay)(refreshData, 5000, props);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    id: fieldId,
    name: fieldName,
    type: "hidden",
    value: props.value
  }));
};
var _default = exports.default = CustomHiddenLeads;